import { cn } from '@/utils/styles';
import { CANCER_DETECT_PATH, HOME_PATH } from '@/constants/paths';
import { useLocation } from 'react-router-dom';
import { Link, type LinkProps } from '@design-system/Link';

export interface DashboardLayoutNavItemProps
  extends Omit<LinkProps, 'to' | 'children'> {
  to: string;
  label?: React.ReactNode;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  activeIcon: React.FC<React.SVGProps<SVGSVGElement>>;
}

const getIsActive = (pathname: string, to: string) => {
  return (to === HOME_PATH ? pathname === to : pathname.includes(to)) || (pathname === CANCER_DETECT_PATH && to === '/');
};

export const DashboardLayoutNavItem = ({
  to,
  icon,
  label,
  className,
  activeIcon,
}: DashboardLayoutNavItemProps) => {
  const { pathname } = useLocation();
  const isActive = getIsActive(pathname, to);

  const IconComponent = isActive ? activeIcon : icon;

  return (
    <Link
      to={to}
      data-active={isActive}
      className={cn('justify-start', className)}
    >
      {IconComponent && (
        <IconComponent width={24} height={24} className="!size-6" aria-hidden />
      )}

      {label && <span className="typography-body">{label}</span>}
    </Link>
  );
};
